/**
 * Generates an accordion effect for a list of elements.
 */
const accordion = () => {
	// Get all elements with the class 'accordion'
	const accordions = Array.from(document.querySelectorAll('.accordion'));
	// Iterate through each element
	accordions.forEach((el) => {
		// Add an event listener to each element that listens for a click event
		el.addEventListener('click', (e) => {
			// Get the current target of the click event
			const self = e.currentTarget;
			// Get the control element
			const control = self.querySelector('.accordion__control');
			// Get the content element
			const content = self.querySelector('.accordion__content');
			// Get the current state of the class list
			const isOpen = self.classList.toggle('open');
			
			// Set the aria-expanded attribute of the control element to the current state of the class list
			control.setAttribute('aria-expanded', isOpen);
			// Set the aria-hidden attribute of the content element to the opposite of the current state of the class list
			content.setAttribute('aria-hidden', !isOpen);
			
			// Stop the propagation of the click event
			e.stopPropagation();
		});
		// Add an event listener to the content element that listens for a click event
		el.querySelector('.accordion__content').addEventListener('click', (e) => {
			// Stop the propagation of the click event
			e.stopPropagation();
		});
	});
};

export default accordion;
